import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu-two',
  templateUrl: './menu-two.component.html',
  styleUrls: ['./menu-two.component.css']
})
export class MenuTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
